import React, { useEffect, useState } from 'react';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import InvestmentAnalyser from 'components/InvestmentAnalyser/InvestmentAnalyser';
import { connect } from 'react-redux';
import { compose } from 'redux-starter-kit';
import api from 'api';
import Store from 'store/store';
import LoaderSpinner from 'components/LoaderSpinner/LoaderSpinner';

const { actions } = Store;

const InvestmentAnalyserPage = ({ updateCashFund }: any) => {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    api.getCashFund().then(data => {
      updateCashFund(data);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Dashboard>
      {loading ? <LoaderSpinner isLoading={loading} /> : <InvestmentAnalyser />}
    </Dashboard>
  );
};

export default compose(
  connect(null, {
    updateCashFund: actions.metaActions.updateCashFund
  })
)(InvestmentAnalyserPage);
